import { type IDynamicEditData, IListEditType } from '@carboncopyco/types';
import { capitalize } from 'lodash-es';

export const lockLabel = 'Block Events';

export const getChartLabel = (edit: IDynamicEditData['element']) => {
  const chartType =
    capitalize(edit.new?.serialized?.charts?.chartType || 'chart') || 'chart';
  return `${chartType} chart changed`;
};

export const getDeleteLabel = (edit: IDynamicEditData['element']) => {
  return `Element ${edit.new.value === 'true' ? 'deleted' : 'restored'}`;
};

export const getImageFileName = (url: string) => {
  const index = url.lastIndexOf('/');
  return url.substring(index + 1);
};

export const isSvg = (url: string) => {
  return url.startsWith('<svg');
};

export const inputLabel = 'Input changed';

export const getListLabel = (edit: IDynamicEditData['element']) => {
  return (
    {
      [IListEditType.up]: `Moved item ${IListEditType.up}`,
      [IListEditType.down]: `Moved item ${IListEditType.down}`,
      [IListEditType.duplicate]: 'Row duplicated',
      [IListEditType.delete]: 'Row deleted',
    }[edit.new.serialized.moveType] || 'List item changed'
  );
};

export const unlockLabel = 'Allow interactions';

export const getVisibilityLabel = (edit: IDynamicEditData['element']) => {
  return edit.new.value === 'true' ? 'Hide element' : 'Show element';
};
